import { Icon, Text } from "@oysterhr/ui"
import { ReactNode } from "react"

export type HiringFlowSectionProps = {
  children: ReactNode
  onDelete?: () => void
  onEdit?: () => void
  title: string
}

export function HiringFlowSection({ onDelete, onEdit, title, children }: HiringFlowSectionProps) {
  return (
    <div className="flex w-full flex-col rounded-lg bg-gray-100 p-4">
      <Title onDelete={onDelete} onEdit={onEdit} title={title} />
      {children}
    </div>
  )
}

const Title = ({
  onEdit,
  onDelete,
  title,
}: Pick<HiringFlowSectionProps, "title" | "onDelete" | "onEdit">) => {
  return (
    <div className="flex justify-between">
      <Text size="large" className="mb-2 font-semibold">
        {title}
      </Text>
      <div className="flex items-center gap-1">
        {!!onEdit && (
          <Icon
            data-testid="section-edit-button"
            className="gray-400 cursor-pointer"
            size="xs"
            name="PencilSimple"
            onClick={() => onEdit()}
          />
        )}
        {!!onDelete && (
          <Icon
            data-testid="section-delete-button"
            className="gray-400 cursor-pointer"
            size="xs"
            name="Trash"
            onClick={() => onDelete()}
          />
        )}
      </div>
    </div>
  )
}

const Subsection = ({ children }: { children: ReactNode }) => {
  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-4 border-t border-gray-200 py-2 last:pb-0">
      {children}
    </div>
  )
}

const DataEntry = ({ title, value }: { title: string; value: string | number }) => {
  return (
    <div className="flex flex-col">
      <Text size="small" className="text-gray-400">
        {title}
      </Text>
      <Text>{value}</Text>
    </div>
  )
}

HiringFlowSection.Subsection = Subsection
HiringFlowSection.DataEntry = DataEntry
